import React from "react";
import "./index.scss";
import { Pagination } from "@mui/material";

const SiPagination = ({ pageCount, page, setPage, onChange }) => {
  return (
    <div>
      {pageCount > 1 && (
        <Pagination
          page={page}
          count={pageCount}
          color="primary"
          size="small"
          hidePrevButton
          hideNextButton
          shape="rounded"
          onChange={(e, page) => {
            setPage(page);
            if (onChange) {
              onChange(page);
            }
          }}
        ></Pagination>
      )}
    </div>
  );
};

export default SiPagination;
